export default __webpack_public_path__ + "static/media/laptop.6956055f.png";